import React, { useContext } from 'react';

import MdForumContext from '@/markdown/modules/MdForumContext';
import Loadable from '@/common/lazy/Loadable';
import imports from '@/routing/imports';

const LoadableEditorWithComments = Loadable({
    loader: imports.betbook,
    exp: Exp => Exp.EditorWithComments
});

function DiscussionComments() {
    const { subjectId, subjectType } = useContext(MdForumContext);
    if (!subjectId || !subjectType) {
        return null;
    }

    return <LoadableEditorWithComments subjectId={subjectId} subjectType={subjectType} />;
}

export default DiscussionComments;
